import styled from "styled-components";

export const AccountUpdatedEntryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 8px;
  transition: all 0.2s ease;
`
export const LeftContent = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`
export const DateDisplay = styled.h4`
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    padding: 8px 8px;
    text-align: center;
    width: 160px;
`
export const ActionDisplay = styled.h4`
    color: #FFFFFF;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
`